import React from 'react';
import { Form, Message, Button } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
// import _find from 'lodash/find';

import EstaSegGral from '../../../components/funcionales/estaseggral'

//utils
import queries from '../../../utils/queries';

import general from '../../../modulos/general';

const styles1 ={
  paraH1:{
      padding: '0em',
      margin: '0em',
      color: '#302b63',
  },
  paraH2_01:{
    padding: '0em',
    margin: '0em',
    color: '#2C7744',
  },
  paraH2_02:{
      padding: '0em',
      margin: '0em',
      color: 'red',
  },
  colorRed:{
      color: 'red',
  },
  colorBlue:{
      color: '#302b63',
  },
  styPaddMarg:{
      padding: '0.2em 0.1em 0.2em 0.1em',
      fontSize: '0.9em'
  },
  styInput:{
    width: '4em',
  },
}

const RecPagoCli = ({styles, elemento, permAct, handleChangeColecc}) => {
  let fechaM = elemento.fechaMov.substr(0,10)
  const valorValido = (valor) => {
    if(valor){
      return valor
    }else{
      return 0
    }
  }
  return(
    <tr className=''>
      <td className=''>{elemento.numeroOdeDX>0?elemento.numeroOdeDX:""}</td>
      <td className=''>{fechaM}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className=''>{elemento.origen}</td>
      <td className=''>{elemento.periodo}</td>
      <td className='' style={elemento.valorTotal<0?{color: 'yellow'}:{color: '#FAFFD1', fontWeight: 'bold'}}>{elemento.valorTotal}</td>
      <td className=''>{elemento.valorPagado}</td>
      <td className=''>{elemento.valorTotal - elemento.valorPagado}</td>
      <td className='center aligned' style={styles.styPaddMarg}>
        <input type='number' step="1" style={styles.styInput} autoComplete="off" name="valorRecibido" id={elemento._id} value={valorValido(elemento.valorRecibido)} placeholder='Paga' onChange={permAct==='cambiar'?(ev)=>handleChangeColecc(ev, elemento):()=>{}}/>
      </td>
    </tr>
  )
};

const ListaRecPago = ({styles, list, permAct, handleChangeColecc}) => {
  const nivel1Detalle = list.map((elemento, _id) => <RecPagoCli styles={styles} elemento={elemento} permAct={permAct} handleChangeColecc={handleChangeColecc} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//dropdown OFICINAS
const DetalleOf1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrOficina}</option>
  )
};

const ListaOf = ({styles, list, handleChangeOf}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleOf1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="oficina" id="miListaOf" onChange={(ev)=>handleChangeOf(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown OFICINAS

//dropdown RANGOS FACT
const DetalleRango = props => {
  return (
    <option dato1={props.elemento._id} dato2={props.elemento.prefijo} value={props.elemento.proxFact}>{props.elemento.prefijo} {props.elemento.factInicial} - {props.elemento.factFinal}</option>
  )
};

const ListaRango = ({styles, handleChange, list}) => {
  let detalleR = list.map((elemento, _id) => <DetalleRango elemento={elemento} key={elemento._id}/>);
  let selecc = false
  if(list.length>1){
    selecc = true
  }
  return(
    <div>
      <select style={styles.input}className="ui simple selection dropdown fluid" name="rango" id="miListaR" onChange={(ev) => handleChange(ev, list)}>
        {selecc &&
        <option value="">Seleccionar rango ...</option>
        }
        {detalleR}
      </select>
    </div>
  )
};
//Fin dropdown RANGOS FACT

class RecPago2 extends React.Component {
  state={
    argsDocumCli: {contrato: this.props.idLista.contrato,
                nombreCliente: this.props.idLista.nombreCliente,
                apellidoCliente: this.props.idLista.apellidoCliente,
                _id: this.props.idLista._id},
                argsAdd: {descrOficina: this.props.descrOficina, numSorteos: this.props.idLista.numSorteos,
                  numeroRT: "",
                  eMail: !this.props.idLista.eMail?'':this.props.idLista.eMail,
                  fechaCumple: !this.props.idLista.fechaCumple?'':this.props.idLista.fechaCumple.substr(0, 10),
                  telefono1: !this.props.idLista.telefono1?'':this.props.idLista.telefono1,
                  datosConfirmados: !this.props.idLista.datosConfirmados?'NO':this.props.idLista.datosConfirmados,
                  valorEf: 0, valorCh: 0, valorTr: 0, valorTC: 0, valorTD: 0},
    confirmaAct: false, listColecc: this.props.list4,
    open: false, listaR: []
  }

  handleChange = (ev, totRecibido, list4)=>{
    // console.log(ev.target.value)
    // console.log(ev.target.name)
    let listColecc = list4.map(recpago => ({...recpago}))
    if(ev.target.name==="valorEf"||ev.target.name==="valorCh"||ev.target.name==="valorTr"||
        ev.target.name==="valorTC"||ev.target.name==="valorTD"){
      let totRecib = 0, valorRdo = 0, valorRdoEf = 0, valorRdoCh = 0, valorRdoTr = 0, valorRdoTC = 0, valorRdoTD = 0
      if(ev.target.value){valorRdo=ev.target.value}
      if(this.state.argsAdd.valorEf){valorRdoEf=this.state.argsAdd.valorEf}
      if(this.state.argsAdd.valorCh){valorRdoCh=this.state.argsAdd.valorCh}
      if(this.state.argsAdd.valorTr){valorRdoTr=this.state.argsAdd.valorTr}
      if(this.state.argsAdd.valorTC){valorRdoTC=this.state.argsAdd.valorTC}
      if(this.state.argsAdd.valorTD){valorRdoTD=this.state.argsAdd.valorTD}
      if(ev.target.name==="valorEf") {
        totRecib = parseInt(totRecibido, 10) - parseInt(valorRdoEf, 10) + parseInt(valorRdo, 10)
      }
      if(ev.target.name==="valorCh") {
        totRecib = parseInt(totRecibido, 10) - parseInt(valorRdoCh, 10) + parseInt(valorRdo, 10)
      }
      if(ev.target.name==="valorTr") {
        totRecib = parseInt(totRecibido, 10) - parseInt(valorRdoTr, 10) + parseInt(valorRdo, 10)
      }
      if(ev.target.name==="valorTC") {
        totRecib = parseInt(totRecibido, 10) - parseInt(valorRdoTC, 10) + parseInt(valorRdo, 10)
      }
      if(ev.target.name==="valorTD") {
        totRecib = parseInt(totRecibido, 10) - parseInt(valorRdoTD, 10) + parseInt(valorRdo, 10)
      }
      listColecc.forEach((elemento, i) => {
        if(elemento.valorTotal<0){
          totRecib -= elemento.valorTotal
          listColecc[i].valorRecibido = elemento.valorTotal
        }
      })
      listColecc.forEach((elemento, i) => {
        if(elemento.valorTotal>0){
          if(totRecib > elemento.valorTotal - elemento.valorPagado){
            totRecib -= (elemento.valorTotal - elemento.valorPagado)
            listColecc[i].valorRecibido = elemento.valorTotal - elemento.valorPagado
          }else{
            listColecc[i].valorRecibido = totRecib
            totRecib = 0
          }
        }
      })
    }
// console.log(listColecc)
    const argsAdd = this.state.argsAdd
    if(ev.target.name==="rango"){
      var miLista = document.getElementById("miListaR");
      argsAdd['_idRango'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['prefijoFact'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      if(ev.target.name==="valorEf"||ev.target.name==="valorCh"||ev.target.name==="valorTr"||
          ev.target.name==="valorTC"||ev.target.name==="valorTD"){
        argsAdd[ev.target.name] = parseInt(ev.target.value, 10)
      }else{
        argsAdd[ev.target.name] = ev.target.value
      }
      argsAdd['contrato'] = this.props.idLista.contrato
    }

    if(ev.target.name==="valorEf"||ev.target.name==="valorCh"||ev.target.name==="valorTr"||
        ev.target.name==="valorTC"||ev.target.name==="valorTD"){
      this.setState({listColecc, argsAdd, confirmaAct: false});
    }else{
      this.setState({argsAdd, confirmaAct: false});
    }
  }

  handleChangeColecc = (ev, elemento) => {
    if(ev.target.name === "valorRecibido"){
      let listColecc = this.state.listColecc.map(recpago => ({...recpago}))
      const indexSearch = listColecc.findIndex( pagar => pagar._id === ev.target.id );
      listColecc[indexSearch].valorRecibido = ev.target.value

      this.setState({listColecc, confirmaAct: false});
    }
  }

  handleChangeOf = (ev) => {
    if(ev.target.name === "oficina"){
      const argsAdd = this.state.argsAdd
      let miLista = document.getElementById("miListaOf");
      argsAdd['descrOficina'] = miLista.options[miLista.selectedIndex].text  
      this.setState({argsAdd, confirmaAct: false});
    }
  }

  handleRefresh = (totRecibido, list4) => {
    let listColecc = list4.map(recpago => ({...recpago}))
    let totRecib = totRecibido
    listColecc.forEach((elemento, i) => {
      if(elemento.valorTotal<0){
        totRecib -= elemento.valorTotal
        listColecc[i].valorRecibido = elemento.valorTotal
      }
    })

    listColecc.forEach((elemento, i) => {
      if(elemento.valorTotal>0){
        if(totRecib > elemento.valorTotal - elemento.valorPagado){
          totRecib -= (elemento.valorTotal - elemento.valorPagado)
          listColecc[i].valorRecibido = elemento.valorTotal - elemento.valorPagado
        }else{
          listColecc[i].valorRecibido = totRecib
          totRecib = 0
        }
      }
    })
    this.setState({listColecc, confirmaAct: false});
  }
  
  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.allRangoFact.allRangoFact){
      if(this.state.listaR.length===0&&this.props.allRangoFact.allRangoFact.length>0){
        let listaR = this.props.allRangoFact.allRangoFact.filter(elemento => elemento.estadoRangoFact===true)
        this.setState({listaR})
      }
    
      // console.log(this.state.argsAdd)
      // console.log(this.state.listaR)
      if(!this.state.argsAdd._idRango&&this.state.listaR.length===1&&this.state.listaR.length>0){
        const argsAdd = this.state.argsAdd
        argsAdd['_idRango'] = this.state.listaR[0]._id
        argsAdd['prefijoFact'] = this.props.prefijoFact
        this.setState({argsAdd});
      }
    }
  }

render(){
  const {argsDocumCli, listColecc, argsAdd, confirmaAct, open, listaR} = this.state;
// console.log(argsDocumCli)
// console.log(this.props.idLista)
// console.log(argsAdd)
// console.log(this.props.modeloFactura)
// console.log(this.props.idLista)
let estadoCliente = this.props.idLista.estadoCliente
let saldoPendiente = this.props.idLista.saldoPendiente

let linea1DNN = ""
let linea2DNN = ""
let linea3DNN = ""
let linea4DNN = ""
let direccion1 = ""
let direccion2 = ""

if(this.props.idLista.direccion.descrTipoVia1){
  linea1DNN = `${this.props.idLista.direccion.descrTipoVia1?this.props.idLista.direccion.descrTipoVia1:""}
    ${this.props.idLista.direccion.numeroTipoVia1?this.props.idLista.direccion.numeroTipoVia1:""}
    ${this.props.idLista.direccion.descrTipoVia2?this.props.idLista.direccion.descrTipoVia2:""}
    ${this.props.idLista.direccion.numeroTipoVia2?this.props.idLista.direccion.numeroTipoVia2:""}
    ${this.props.idLista.direccion.numeroTipoVia2F?this.props.idLista.direccion.numeroTipoVia2F:""}
    ${this.props.idLista.direccion.descrTipoUnd1?this.props.idLista.direccion.descrTipoUnd1:""}
    ${this.props.idLista.direccion.numeroTipoUnd1?this.props.idLista.direccion.numeroTipoUnd1:""}
    ${this.props.idLista.direccion.descrTipoUnd2?this.props.idLista.direccion.descrTipoUnd2:""}
    ${this.props.idLista.direccion.numeroTipoUnd2?this.props.idLista.direccion.numeroTipoUnd2:""}`

    linea2DNN = `${this.props.idLista.direccion.descrTiUndMat?this.props.idLista.direccion.descrTiUndMat:""}
    ${this.props.idLista.direccion.descrUndMat?this.props.idLista.direccion.descrUndMat:""}`

    linea3DNN = `${this.props.idLista.dirmayor.descrDpto?this.props.idLista.dirmayor.descrDpto:""}
    ${this.props.idLista.dirmayor.ciudades.nombreCiudad?", " + this.props.idLista.dirmayor.ciudades.nombreCiudad:""}`

    linea4DNN = `${this.props.idLista.dirmayor.ciudades.zonas.nombreZona?", Zona: " + this.props.idLista.dirmayor.ciudades.zonas.nombreZona:""}
    ${this.props.idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio?", Barrio: " + this.props.idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio:""}`

    direccion1 = linea1DNN + ' ' + linea2DNN
    direccion2 = linea3DNN + ' ' + linea4DNN
  }

  let totRecibido = 0
  if(argsAdd.valorEf) {
    totRecibido += parseInt(argsAdd.valorEf, 10)
  }
  if(argsAdd.valorCh) {
    totRecibido += parseInt(argsAdd.valorCh, 10)
  }
  if(argsAdd.valorTr) {
    totRecibido += parseInt(argsAdd.valorTr, 10)
  }
  if(argsAdd.valorTC) {
    totRecibido += parseInt(argsAdd.valorTC, 10)
  }
  if(argsAdd.valorTD) {
    totRecibido += parseInt(argsAdd.valorTD, 10)
  }

  let texto='Recibir pago'
  if(totRecibido>saldoPendiente){
    texto += ` - Tiene un saldo de ${saldoPendiente}, y va a RECIBIR UN PAGO POR MAYOR VALOR DE ${totRecibido}`
  }

  const a01015010 = this.props.autorizacUA.findIndex( autorizac => autorizac === "01015010" );
  // console.log(a01015010)
  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
        <i className="large hand point down yellow icon"></i>
        Cliente
      </button>
      <div>

      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
        <div>
          <h1 style={styles1.paraH1}>
            {argsDocumCli.contrato} - {argsDocumCli.nombreCliente} {argsDocumCli.apellidoCliente} - &nbsp;&nbsp;
            <span style={estadoCliente!=='ACTIVO'?styles1.paraH2_02:styles1.paraH2_01}>
              {estadoCliente}
            </span>
          </h1>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '65%'}}>
                <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                  {direccion1}<br/>
                  {direccion2}
                </p>
              </div>
              <div className="column" style={{width: '35%'}}>
                <p>
                  <span style={{background: '#7F7FD5', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                    Saldo: &nbsp;&nbsp;
                    <span style={{color: '#302b63', fontSize: '2em'}}> ${general.formatNum(saldoPendiente.toString())}</span>
                  </span>
                </p>
              </div>
            </div>
          </div>


          {/* {(saldoPendiente<=0) &&
            <div>
              <hr></hr>
              <div className="ui one column stackable grid">
                <div className="row container">
                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    &nbsp;&nbsp;&nbsp;&nbsp;El cliente debe tener saldo pendiente mayor que cero
                    </p>
                </div>
              </div>
              <hr></hr>
            </div>
          } */}

          {/* {(saldoPendiente>0) && */}
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsAdd, listColecc, totRecibido, listaR, this.props.ajCero):()=>{}}>
            <div>
              <hr></hr>

              <div className="ui three column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '15%'}}>
                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Recibir pago
                    </p>
                  </div>
                  <div className="column" style={{width: '35%'}}>
                    <p>
                      <span style={{background: '#7F7FD5', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                        Total recibido: &nbsp;&nbsp;
                        <span style={{color: '#302b63', fontSize: '2em'}}> ${totRecibido}</span>
                      </span>
                    </p>
                  </div>
                  {(!this.props.descrOficina||this.props.descrOficina==="Todas...") &&
                    <div className="column" style={{width: '35%'}}>
                      <label style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold'}}>Oficina</label>
                      <Form.Field>
                        <ListaOf styles={this.props.styles} list={this.props.listaOf} handleChangeOf={this.handleChangeOf}/>
                      </Form.Field>
                    </div>
                  }
                  {this.props.empresaArchFE==="sinergy" &&
                    <div className="column" style={{width: '15%'}}>
                      <label style={{...this.props.styles.label, color: '#302b63', fontSize: '1em', fontWeight: 'bold'}}># Recibo</label>
                      <input style={this.props.styles.input} autoComplete="off" name="numeroRT" id="numeroRT"
                        onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)} placeholder='# Recibo'/>
                    </div>
                  }

                  {/* {this.props.modeloFactura==="1" &&
                    <div className="column" style={{width: '15%'}}>
                      <label style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold'}}># para Sorteos</label>
                      <input style={this.props.styles.input} autoComplete="off" name="numSorteos" id="numSorteos"
                        value={argsAdd.numSorteos?argsAdd.numSorteos:""} pattern={"[A-C]{1}[0-9]{4}"}
                        onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)} placeholder='# para Sorteos'/>
                    </div>
                  } */}

                  {/* El siguiente div es para que funcione otra forma de addImage en home.js en handleRecPago
                  <div id="divLogo"  className="column" style={{width: '30%'}}>
                  </div> */}
                </div>
              </div>

              {(a01015010!==-1&&argsAdd.datosConfirmados==="NO") &&
                <div>
                  <hr></hr>
                  <div className="ui three column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '25%'}}>
                        <label style={{...this.props.styles.label, color: '#302b63', fontSize: '1em', fontWeight: 'bold'}}>Teléfono 1</label>
                        <Form.Field>
                          <input style={{...this.props.styles.input, width: '60%'}} pattern={"[0-9]{7,10}"}
                            autoComplete="off" name="telefono1" id="telefono1" value={argsAdd.telefono1}
                            onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)}
                            placeholder='Teléfono 1'/>
                        </Form.Field>
                      </div>
                      <div className="column" style={{width: '40%'}}>
                        <label style={{...this.props.styles.label, color: '#302b63', fontSize: '1em', fontWeight: 'bold'}}>Correo electrónico</label>
                        <input style={{...this.props.styles.input, width: '90%'}} pattern={"[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\.[a-z]{0,}$"}
                          autoComplete="off" name="eMail" id="eMail" value={argsAdd.eMail}
                          onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)}
                          placeholder='Correo electrónico'/>
                      </div>
                      <div className="column" style={{width: '35%'}}>
                        <label style={{...this.props.styles.label, color: '#302b63', fontSize: '1em', fontWeight: 'bold'}}>Fecha de cumpleaños</label>
                        <Form.Field>
                          <input style={{...this.props.styles.input, width: '60%'}} type='date'
                            name="fechaCumple" id="fechaCumple" value={argsAdd.fechaCumple}
                            onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)}/>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <hr></hr>

              {listaR.length>10 &&
                <div className="column" style={{width: '50%'}}>
                  <label style={{color: '#302b63'}}>Rangos de facturación</label>
                  <ListaRango list={listaR} styles={this.props.styles} handleChange={this.handleChange}/>
                </div>
              }

              <div className='ui blue inverted raised segment'>
                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" width="100%">
                      <Form.Field>
                        <div className="column" style={{width: '23%'}}>
                          <label style={this.props.styles.label}>$ Efectivo</label>
                          <input type='number' step="1" min="0" autoFocus style={this.props.styles.input} autoComplete="off" name="valorEf" id="valorEf" placeholder='Efectivo' onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)}/>
                        </div>
                      </Form.Field>
                      <Form.Field>
                        <div className="ui four column stackable grid">
                          <div className="column" style={{width: '25%'}}>
                            <label style={this.props.styles.label}>$ Cheque</label>
                            <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorCh" id="valorCh" placeholder='Cheque' onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)}/>
                          </div>
                          <div className="column" style={{width: '25%'}}>
                            <label style={this.props.styles.label}># cheque</label>
                            <input style={this.props.styles.input} autoComplete="off" name="numeroCh" id="numeroCh" onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)} placeholder='# cheque'/>
                          </div>
                          <div className="column" style={{width: '25%'}}>
                            <label style={this.props.styles.label}>Banco</label>
                            <input style={this.props.styles.input} autoComplete="off" name="bancoCh" id="bancoCh" onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)} placeholder='Banco'/>
                          </div>
                          <div className="column" style={{width: '25%'}}>
                            <label style={this.props.styles.label}>Fecha vencimiento</label>
                            <input style={this.props.styles.input} type='date' name="fechaVencCh" id="fechaVencCh" onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)}/>
                          </div>
                        </div>
                      </Form.Field>
                      <Form.Field>
                        <div className="ui four column stackable grid">
                          <div className="column" style={{width: '25%'}}>
                            <label style={this.props.styles.label}>$ Transferencia</label>
                            <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTr" id="valorTr" placeholder='Transferencia' onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)}/>
                          </div>
                          <div className="column" style={{width: '25%'}}>
                            <label style={this.props.styles.label}>Banco</label>
                            <input style={this.props.styles.input} autoComplete="off" name="bancoTr" id="bancoTr" onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)} placeholder='Banco'/>
                          </div>
                          <div className="column" style={{width: '25%'}}>
                            <label style={this.props.styles.label}>Fecha transferencia</label>
                            <input style={this.props.styles.input} type='date' name="fechaTr" id="fechaTr" onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)}/>
                          </div>
                        </div>
                      </Form.Field>
                      <Form.Field>
                        <div className="ui four column stackable grid">
                          <div className="column" style={{width: '25%'}}>
                            <label style={this.props.styles.label}>$ Tarjeta débito</label>
                            <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTD" id="valorTD" placeholder='Valor' onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)}/>
                          </div>
                          <div className="column" style={{width: '25%'}}>
                            <label style={this.props.styles.label}>Banco</label>
                            <input style={this.props.styles.input} autoComplete="off" name="bancoTD" id="bancoTD" onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)} placeholder='Banco'/>
                          </div>
                        </div>
                      </Form.Field>
                      <Form.Field>
                        <div className="ui four column stackable grid">
                          <div className="column" style={{width: '25%'}}>
                            <label style={this.props.styles.label}>$ Tarjeta crédito</label>
                            <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTC" id="valorTC" placeholder='Valor' onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)}/>
                          </div>
                          <div className="column" style={{width: '25%'}}>
                            <label style={this.props.styles.label}>Banco</label>
                            <input style={this.props.styles.input} autoComplete="off" name="bancoTC" id="bancoTC" onChange={(ev) => this.handleChange(ev, totRecibido, this.props.list4)} placeholder='Banco'/>
                          </div>
                        </div>
                      </Form.Field>
                    </div>
                  </div>
                </div>
              </div>

              <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className=''>DX</th>
                    <th className=''>Fecha</th>
                    <th className=''>Servicio</th>
                    <th className=''>Concepto</th>
                    <th className=''>Periodo</th>
                    <th className=''>Valor</th>
                    <th className=''>Pagado</th>
                    <th className=''>Debe</th>
                    <th className='center aligned'>&nbsp;&nbsp;
                      <button className="ui right labeled icon button" name="paga" id="paga" type="button" style={this.props.styles.styBtn} onClick={() => this.handleRefresh(totRecibido, this.props.list4)}>
                        <i className='redo icon'></i>
                        Paga
                      </button>
                    </th>
                    {/* <th className='center aligned'>Paga&nbsp;&nbsp;
                      <a className='ui large label' name="paga" id="paga" style={this.props.styles.styTableInf}><i className='redo icon' onClick={() => this.handleRefresh(totRecibido, this.props.list4)}/></a>
                    </th> */}
                  </tr>
                </thead>
                {/* <ListaRecPago styles={this.props.styles} list={listColecc} permAct='cambiar' handleChangeColecc={this.handleChangeColecc}/> */}
                <ListaRecPago styles={this.props.styles} list={listColecc} permAct='NOcambiar' handleChangeColecc={this.handleChangeColecc}/>
              </table>
            </div>

            <hr></hr>

            {/* {totRecibido<saldoPendiente && */}
            {totRecibido!==saldoPendiente &&
              <EstaSegGral btnText={texto} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
            }
            {/* {totRecibido>=saldoPendiente && */}
            {totRecibido===saldoPendiente &&
              <Button className='ui right labeled icon button' style={this.props.styles.titBuscar} onClick={(ev)=>this.props.handleSubmit(ev, argsAdd, listColecc, totRecibido, listaR, this.props.ajCero)} primary fluid>
                <i className='large edit yellow icon'></i>
                Recibir pago
              </Button>
            }
            </Form>
            {
                this.props.errors.length?<Message negative header="Los siguientes errores:"
                list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }

            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
    graphql(queries.query.allRangoFact, {name:'allRangoFact', options: (props) => {return {variables: {}}}}),

    //Aunque no se necesita, se deja createCliente para mantener  la posibilidad de agregar querys
    graphql(queries.mutation.createCliente, {name:'createCliente'}),
    // graphql(queries.mutation.editCliente, {name:'editCliente'}),
    // graphql(queries.mutation.createServicio, {name:'createServicio'}),
    
    graphql(queries.query.allOficina, {name:'allOficina'}),
  )(RecPago2)